import { apiClient } from './client';
import type { SchedulerView, ThemePreference, User } from '../types';

interface UpdatePrefsBody {
  fullName?: string | null;
  defaultView?: SchedulerView;
  themePreference?: ThemePreference;
}

export const usersApi = {
  async getMe(): Promise<User> {
    const response = await apiClient.get<User>('/users/me');
    return response.data;
  },

  async updatePrefs(data: UpdatePrefsBody): Promise<User> {
    const response = await apiClient.patch<User>('/users/me', data);
    return response.data;
  },

  async setOnboardingStep(step: number): Promise<{ onboardingStep: number }> {
    const response = await apiClient.patch<{ onboardingStep: number }>(
      '/users/me/onboarding-step',
      { step },
    );
    return response.data;
  },

  async completeOnboarding(): Promise<{ onboardingCompleted: boolean }> {
    const response = await apiClient.post<{ onboardingCompleted: boolean }>(
      '/users/me/onboarding-complete',
    );
    return response.data;
  },
};
